import { Component, EventEmitter, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sign-in-form',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './sign-in-form.component.html',
  styleUrl: './sign-in-form.component.css'
})
export class SignInFormComponent {
  signInForm: FormGroup;
  hidePassword = signal(true);
  @Output() createAccountEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder, private router: Router) {
    this.signInForm = this.fb.group({
      email: ['', Validators.required, Validators.email],
      password: ['', Validators.required, Validators.minLength(6)],
    });
  }

  clickPasswordEvent(event: MouseEvent) {
    this.hidePassword.set(!this.hidePassword());
    event.stopPropagation();
  }

  onCreateAccountLink() {
    this.createAccountEmitter.emit(false);
  }

  onSubmit () {
    console.log('Form submitted: ', this.signInForm.value);
    // if (this.signInForm.invalid) {
    //   this.signInForm.markAllAsTouched();
    //   return;
    // }
    this.router.navigate(['/survey']);
  }
}
